export default {
  itemDetails: [],
  first_name: '',
  last_name: '',
  email_address: '',
  start_date: '',
  expiry_date: '',
  cover_period: '',
  total_value: '0',
  premium: '',
  levy: ''    
}